import { render, staticRenderFns } from "./IssueDocumentDuplicate.vue?vue&type=template&id=e7303b00"
import script from "./IssueDocumentDuplicate.vue?vue&type=script&lang=ts"
export * from "./IssueDocumentDuplicate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports